const prestations = [

"Placement",
"Gestion",
"Délégation",
"Je ne sais pas",



]



export default prestations;